import gql from 'graphql-tag';

export const GET_ATTENDEES = gql`
  query(
    $name: String!
    $isClient: Boolean!
    $isStaffPage: Boolean
    $shouldExcludeActive: Boolean
  ) {
    attendees(
      name: $name
      isClient: $isClient
      isStaffPage: $isStaffPage
      shouldExcludeActive: $shouldExcludeActive
    ) {
      id
      corticaPrograms {
        id
        programName
      }
      certificationMappings {
        id
        certificationDate
        renewalDate
        certification {
          id
          certificationName
        }
      }
      displayName
      attendeeType
      name
      status
      isActive
      speciality {
        id
        color
        abbreviation
        department
      }
      clinic {
        id
        abbreviation
        timezone
      }
      appointmentTypes {
        id
        title
        eventType {
          id
          name
        }
      }
      email
      profile {
        dob
      }
      telehealthLinks
      providerCapacity {
        id
        providerTargetSessions
        providerBookedSessions
      }
    }
  }
`;
